import React, { Fragment, useCallback, useRef, useState } from 'react';

import { Formik, Form, Field } from 'formik';

import { ErrorText } from '../../../components-reactjs/ErrorText';
import { CurrencyInput } from '../../../components-reactjs/CurrencyInput';
import { Descricao } from '../styles';
import { useOutsideClick } from '../../../hooks/useOnClickOutside';
import { moneyFieldSchema } from '../../../constants/schemas';

import {
    FixedPriceContainer,
    FieldContainer,
    ButtonsRow,
    CancelButton,
    SaveButton
} from './styles';

export const FixedPrice = ({ selectedCfg, handlerFixedValue }) => {
    const [hasFocus, setHasFocus] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = useCallback(async ({ vlFrete }) => {
        setIsLoading(true);
        let condicaoFrete = {};

        if (selectedCfg && selectedCfg.condicaoFrete.length) {
            const [condicao] = selectedCfg.condicaoFrete;
            condicaoFrete = condicao;
        } else {
            condicaoFrete = {
                idClausulaOperador: 2,
                vlCondicaoFrete: 0,
                vlFrete: 5,
                tpPrioridade: 1
            };
        }

        let valueOfVlFrete = vlFrete;

        if (typeof vlFrete === 'string') {
            valueOfVlFrete = vlFrete.replace(',', '.');
        }

        condicaoFrete.vlFrete = parseFloat(valueOfVlFrete);

        handlerFixedValue(condicaoFrete);

        setIsLoading(false);
    });

    const fieldRef = useRef(null);

    let verify = false;
    let validateCopy = null;

    useOutsideClick(fieldRef, () => {
        setHasFocus(false);
        if (verify) validateCopy();
    });

    const value =
        (selectedCfg.condicaoFrete.length &&
            selectedCfg.condicaoFrete[0].vlFrete) ||
        '';

    return (
        <Formik
            initialValues={{
                vlFrete: value
            }}
            validateOnChange={false}
            validationSchema={moneyFieldSchema}
            onSubmit={onSubmit}
        >
            {(props) => {
                const { values, setFieldValue, errors, validateForm } = props;
                verify = true;
                validateCopy = validateForm;
                return (
                    <Form>
                        <Fragment>
                            <FixedPriceContainer
                                ref={fieldRef}
                                className="container"
                            >
                                <FieldContainer className="field">
                                    <Descricao htmlFor="vlFrete">
                                        Valor do frete
                                    </Descricao>
                                    <Field name="vlFrete">
                                        {({ field, meta }) => {
                                            return (
                                                <Fragment>
                                                    <CurrencyInput
                                                        placeholder="R$ 0"
                                                        onFocus={() => {
                                                            setHasFocus(true);
                                                        }}
                                                        intlConfig={{
                                                            locale: 'pt-BR',
                                                            currency: 'BRL'
                                                        }}
                                                        $hasAnError={
                                                            !!errors.vlFrete
                                                        }
                                                        onValueChange={(
                                                            value
                                                        ) =>
                                                            setFieldValue(
                                                                'vlFrete',
                                                                value
                                                            )
                                                        }
                                                        onBlur={() =>
                                                            field.onBlur
                                                        }
                                                        value={values.vlFrete}
                                                        allowNegativeValue={
                                                            false
                                                        }
                                                        style={{
                                                            height: 36,
                                                            maxWidth: 220
                                                        }}
                                                    />
                                                    {!!meta.error && (
                                                        <ErrorText
                                                            message={meta.error}
                                                        />
                                                    )}
                                                </Fragment>
                                            );
                                        }}
                                    </Field>
                                </FieldContainer>
                                {hasFocus && (
                                    <ButtonsRow className="row">
                                        <SaveButton
                                            isLoading={isLoading}
                                            title="Salvar"
                                            type="submit"
                                        />
                                        <CancelButton
                                            title="Cancelar"
                                            onClick={() => setHasFocus(false)}
                                        />
                                    </ButtonsRow>
                                )}
                            </FixedPriceContainer>
                        </Fragment>
                    </Form>
                );
            }}
        </Formik>
    );
};
